module.exports = __webpack_public_path__ + "static/media/spid-idp-spiditalia~GdXfNloS.e45c9e05.svg";